import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import { useEffect, useRef } from 'react';
import useFormAPI from '../api';
import Utils from '../../../../utils';

var useFormLoader = function useFormLoader(props) {
  var formContent = props.formContent,
      formData = props.formData;
  var readonly = props.readonly,
      contactId = props.contactId,
      context = props.context;
  var options = props.options,
      renderOptions = props.renderOptions;
  var formRef = useRef({});
  var formApi = useFormAPI();
  var state = formApi.state,
      dispatch = formApi.dispatch;
  var stage = state.stage;
  useEffect(function () {
    if (!formContent) return;
    var _formRef$current = formRef.current,
        oldFormContent = _formRef$current.formContent,
        oldFormData = _formRef$current.formData;
    var formContentChanged = formContent !== oldFormContent;
    if (!readonly && formData && !oldFormData && !formContentChanged) return;
    var form = Utils.string2xml(formContent);
    dispatch({
      type: 'FORM_LOADED',
      payload: {
        form: form
      }
    });
    dispatch({
      type: 'SET_FORM_OPTIONS',
      payload: options
    });
    var languageId = navigator.language || navigator.userLanguage;
    dispatch({
      type: 'SET_FORM_RENDER_OPTIONS',
      payload: _objectSpread({
        languageId: languageId
      }, renderOptions || {})
    });
    formRef.current = {
      readonly: readonly,
      formData: formData,
      formContent: formContent
    };
  }, [formContent, readonly, formData]);
  useEffect(function () {
    switch (stage) {
      case 'formLoaded':
        formApi.loadContext(contactId, context);
        break;

      case 'contextLoaded':
        formApi.loadData(formData ? Utils.string2xml(formData) : null);
        break;

      case 'dataLoaded':
        {
          if (!readonly) {
            formApi.loadBinding();
          } else {
            // disable all input fields from form
            var fields = formApi.searchFields({
              type: 'unknown',
              inputFieldsOnly: true
            });

            var _options = fields.map(function (field) {
              return {
                id: field.id,
                updateProperties: {
                  readonly: true,
                  lookupVisiblity: 'hide'
                }
              };
            });

            formApi.updateFields(_options);
            dispatch({
              type: 'DATA_BINDING_RESOLVED'
            });
          }
        }
        break;
    }
  }, [stage]);
  return {
    state: state,
    formApi: formApi
  };
};

export default useFormLoader;